<template lang="pug">
  div
    slot(name='children'
        v-bind:genericParentContainer='innerContainer',
         v-bind:parentContainer='outerContainer')

    //events(:holder='',@drag-start='cache = false',@drag-end='cache = true')

    cache-as-bitmap(v-if='complexity >= 3 && !context.insideToy && cache',
                    :container='innerContainer',
                    :render-tools='renderTools')

    children(v-if='rendered',:children='toy.transforms',
      :parent-container='innerContainer',
      :depth='depth+1',
      :parent-transform='transform',
      :partutil='toyPartutil',
      :context='toyContext',
      :render-tools='renderTools',
      @loaded='toyLoaded')
      template(#child="{depth,displayObject,innerContainer,outerContainer,transform,parentTransform,context,holder}")
        slot(v-if='createInteractiveChildren',name='holder',
          v-bind:holder='holder',
          v-bind:transform='originalTransform',
          v-bind:innerContainer='innerContainer',
          v-bind:outerContainer='outerContainer',
          v-bind:depth='depth',
          v-bind:parentTransform='originalTransform',
          v-bind:context='makeContext(transform, context)',
          @dragging='dragging',
          v-bind:displayObject='displayObject')

    slot(v-if='rendered',name='holder',
      v-bind:holder='holder',
      v-bind:transform='originalTransform',
      v-bind:innerContainer='innerContainer',
      v-bind:outerContainer='outerContainer',
      v-bind:depth='depth',
      v-bind:context='mainContext',
      v-bind:parent-transform='parentTransform',
      v-bind:displayObject='outerContainer')

</template>
<script>
import Children from './Children.vue';
import FreezedContainer from '../render/freezedcontainer.js';
import CacheAsBitmap from './CacheAsBitmap.vue';
import GetContainerBounds from './GetContainerBounds.vue';
import Overlay from './Overlay.vue';
import Holder from '@edit/render/holder.js';
import Partutil from '@edit/tree/partutil.js';
export default {
  props:{
    transform:{
      type:Object,
      required:true
    },
    innerContainer:{
      type:Object,
      required:true
    },
    outerContainer:{
      type:Object,
      required:true
    },
    renderTools:{
      type:Object,
      required:true
    },
    partutil:{
      type:Object,
      required:true
    },
    depth:{
      type:Number,
      required:true
    },
    holder: {
      type: Object,
      required: true
    },
    context: {
      type: Object,
      required: true
    },
    parentTransform:{
      type:Object,
      required:true
    }
  },
  components:{
    GetContainerBounds,
    Children,
    CacheAsBitmap,
    Overlay,
    Transform: () => import('./Transform.vue')
  },
  data() {
    const component = this.partutil.findComponentForTransform(this.transform);
    const toyAndSource = this.partutil.gamedata.getToyById(component.tid);
    const toyPartutil = new Partutil(toyAndSource);
    const toy = toyAndSource.from;
    const toyContext = Object.assign({}, this.context, {
      insideToy:true,
      noCacheAsBitmap:true,
      overrideLayer: this.transform.transform.layer
    });
    return {
      component,
      toyPartutil,
      toyContext,
      toy,
      cache:false,
      complexity:0,
      rendered: false,
      isWaiting: true
    }
  },
  mounted() {
    this.holder.events().on('drag-start', () => {
      console.log('drag on the toy');
      //this.cache = false;
    });
    this.holder.events().on('drag-end', () => {
      console.log('drag on the toy2');
      //this.cache = true;
    });
    this.renderTools.addToEnterBatch({
      enter:() => {
      }
    });
    this.renderTools.addToUpdateBatch({
      update:() => {
        this.rendered = true;
        if (this.isWaiting) {
          this.renderTools.addToWaitBatch(this.waiting.bind(this));
        }
      }
    })

    this.complexity = this.calculateComplexity();
  },
  beforeDestroy() {
    this.holder.events().off('drag-start');
    this.holder.events().off('drag-end');
  },
  methods:{
    calculateComplexity() {
      function countChildren(transform) {
        const children = (transform.children||transform.transforms);
        const childrenCount = children.reduce( (a,b) => {
          return a + countChildren(b);
        }, 0);
        return 1 + childrenCount;
        //return transform.children.length + reducekocountChildren
      }
      return countChildren(this.toy);
    },
    makeContext(child, inCtx) {
      let zindex = child.zIndex;

      if (isNaN(zindex) || zindex === 1) {
        if (this.originalTransform.zIndex !== 1) {
          zindex = this.originalTransform.zIndex;
        }
      }
      return Object.assign({}, this.toyContext, {
        interactiveOverrideZindex: child.zIndex,
        interactiveOverrideIndirectTransform: this.createInteractiveChildren  ? this.transform : undefined
        //interactiveOverrideIndirectTransform: this.originalTransform
      }, inCtx);
    },
    toyLoaded() {
      this.$emit("loaded");
      this.renderTools.addToRunBatch( () => {
          this.cache = true;
          this.isWaiting = false;
      });
      //this.cache = true;
    },
    dragging() {
      console.log('dragging');
    },
    waiting() {
      if (this.isWaiting) {
        console.log('[Toy Loading]');
        this.renderTools.addToWaitBatch(this.waiting.bind(this));
      }
    }
  },
  computed:{
    originalTransform() {
      return this.transform;
    },
    createInteractiveChildren() {
      return false;
      return this.complexity > 4 && this.complexity < 20;
    },
    mainContext() {
      if (this.createInteractiveChildren) {
        return {
          hack: true,
          interactiveOverrideIndirectTransform: this.context.insideToy? this.transform : undefined
        }
      } else {
        let transformZIndex = parseInt(this.transform.zIndex);
        let childZIndex = parseInt((this.toy.transforms[0]||{}).zIndex);
        if (isNaN(transformZIndex)) {
          transformZIndex = -99999;
        }
        if (isNaN(childZIndex)) {
          childZIndex = -9999999;
        }
        const highestZIndex = Math.max(transformZIndex, childZIndex);
        // TODO: this makes shortpress border change not work? lol
        return {
          interactiveOverrideZindex: highestZIndex
        }
      }
    }
  },
  watch:{
  }
}
</script>
